import React from "react";
import Sidebar from "./Sidebar";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Breadcrumbs = ({ items }) => (
  <div data-testid="breadcrumbs" className="flex items-center gap-2 text-sm text-zinc-500 mb-6">
    {items.map((it, i) => (
      <React.Fragment key={`${it.label}-${it.to || "current"}`}>
        {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-zinc-400" />}
        {it.to ? (
          <Link to={it.to} className="hover:text-zinc-900 transition-colors">{it.label}</Link>
        ) : (
          <span className="text-zinc-800 font-medium">{it.label}</span>
        )}
      </React.Fragment>
    ))}
  </div>
);

const Shell = ({ children }) => {
  return (
    <div className="min-h-screen">
      <Sidebar />
      <main className="ml-64 min-h-screen bg-[#fafafa]">
        <div className="max-w-[1900px] px-10 py-10">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Shell;
